(function () {
  var HERO_ID     = 'shopify-section-slideshow_FDGjK8';
  var FEATURED_ID = 'shopify-section-featured_collection';
  var isMobile    = window.matchMedia('(max-width: 768px)').matches;

  // --- Hero parallax (desktop only) ---
  if (!isMobile) {
    var hero = document.getElementById(HERO_ID);
    var heroMedia = hero ? hero.querySelector('.banner__media') : null;
    if (heroMedia) {
      heroMedia.style.willChange = 'transform';
      window.addEventListener('scroll', function () {
        heroMedia.style.transform = 'translateY(' + window.scrollY * 0.35 + 'px)';
      }, { passive: true });
    }
  }

  // --- Inject light separators between sections (desktop only) ---
  if (!isMobile) {
    var allSections = document.querySelectorAll('main > .shopify-section');
    allSections.forEach(function (section) {
      if (section.id === HERO_ID) return;
      var sep = document.createElement('div');
      sep.className = 'ol-sep';
      section.parentNode.insertBefore(sep, section);
    });
  }

  // -----------------------------------------------------------------------
  // ALL VIEWPORTS: reveal each section as it scrolls into view
  // CSS sets opacity:0 / translateY initially — JS only adds 'ol-in-view'
  // -----------------------------------------------------------------------
  var sections = document.querySelectorAll('main > .shopify-section');

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target.id === HERO_ID) return;

      if (entry.isIntersecting) {
        entry.target.classList.add('ol-in-view');

        // Fire separator sweep on desktop
        if (!isMobile) {
          var prev = entry.target.previousElementSibling;
          if (prev && prev.classList.contains('ol-sep')) {
            prev.classList.add('ol-sep--active');
          }
        }
      } else {
        // Reset so animation replays on re-entry
        entry.target.classList.remove('ol-in-view');
        if (!isMobile) {
          var prev2 = entry.target.previousElementSibling;
          if (prev2 && prev2.classList.contains('ol-sep')) {
            prev2.classList.remove('ol-sep--active');
          }
        }
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(function (s) { obs.observe(s); });

  // --- Featured collection: stagger cards individually (desktop only) ---
  if (!isMobile) {
    var featuredSection = document.getElementById(FEATURED_ID);
    if (featuredSection) {
      var cards = featuredSection.querySelectorAll('.card-wrapper');
      cards.forEach(function (card, i) {
        card.style.opacity    = '0';
        card.style.transform  = 'translateY(50px)';
        card.style.transition = 'opacity 0.6s ease ' + (i * 0.1) + 's, transform 0.6s ease ' + (i * 0.1) + 's';
      });
      var cardObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.card-wrapper').forEach(function (card) {
            card.style.opacity   = '1';
            card.style.transform = 'translateY(0)';
          });
          cardObs.disconnect();
        });
      }, { threshold: 0.05 });
      cardObs.observe(featuredSection);
    }
  }

})();
